export default "__VITE_ASSET__39f00e3c__"